import "./GarbageBagSolutions.module.css";
import IndustrialLeadershipHeader from "@/reusable_sections/Header";
import GlobalPlasticManufacturingHero from "./sections/GlobalPlasticManufacturingHero";
import ManufacturingScaleStats from "./sections/ManufacturingScaleStats";
import CoreProductCategories from "./sections/CoreProductCategories";
import FeaturedWholesaleProducts from "./sections/FeaturedWholesaleProducts";
import CustomProductionAdvantages from "./sections/CustomProductionAdvantages";
import QualityAssuranceStandards from "./sections/QualityAssuranceStandards";
import IndustrialFooter from "@/reusable_sections/Footer";
export default function GarbageBagSolutionsPage() {
  return <div>
      <IndustrialLeadershipHeader />
      <GlobalPlasticManufacturingHero />
      <ManufacturingScaleStats />
      <CoreProductCategories />
      <FeaturedWholesaleProducts />
      <CustomProductionAdvantages />
      <QualityAssuranceStandards />
      <IndustrialFooter />
    </div>;
}